import React from 'react';
import * as LucideIcons from 'lucide-react';

// Convert kebab-case icon names (e.g., "building-2") to PascalCase component names (e.g., "Building2")
function toPascalCase(str) {
  return str
    .split('-')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
}

export const IconFromString = ({ name, size = 14, className = '' }) => {
  if (!name) return null;

  const componentName = toPascalCase(name);
  const IconComponent = LucideIcons[componentName];

  if (IconComponent) {
    return <IconComponent size={size} className={className} />;
  }

  // Fallback: render string as-is (emoji or unknown)
  return <span className={className}>{name}</span>;
};
